const initializeLazyIframes = () => {
  document.querySelectorAll('iframe[data-src]').forEach((iframe) => {
    if (iframe.dataset.lazyLoaded === 'true') {
      return;
    }

    const src = iframe.getAttribute('data-src');

    if (!src) {
      return;
    }

    iframe.setAttribute('src', '');

    setTimeout(() => {
      iframe.setAttribute('src', src);
      iframe.dataset.lazyLoaded = 'true';
    }, 100);
  });
};

if (!window.__iiagLazyIframesInitialized) {
  window.__iiagLazyIframesInitialized = true;
  window.addEventListener('load', initializeLazyIframes);
}
